import React, {Suspense, useEffect, useState, lazy} from 'react'
import styled from 'styled-components'
import {includes} from 'lodash'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {Redirect, Switch, Route} from 'react-router-dom'
import Content from './Content'
import Sidebar from './Sidebar'
import Directions from 'Directions'
import Members from 'members/components/Members'
import LandingPageForSubscription from 'payments/components/LandingPage'
import SuccessPageForSubscription from 'payments/components/SubscriptionSuccessPage'
import CancelPageForSubscription from 'payments/components/SubscriptionCancelPage'
import {Messages} from 'messages/components'
import Activities from 'activities/components/Activities'
import Download from 'app/components/Download'
import isPhone from 'lib/isPhone'
import {getHasClubs, getActive, getIsFetching} from 'clubs/selectors'
import {getIsFetching as getIsFetchingGroups} from 'groups/selectors'
import {getReady, getAuthenticated, getSponsor} from 'authentication'
import getGrowthbookUrl from 'jsonFetches/getGrowthbookUrl'
import {getIsMember} from 'user'
import Sponsor from './Sponsor'
import {
  Login,
  ForgotPassword,
  Logout,
  ResetPassword,
  Payments,
  CreateUser,
  Onboarding,
  Overview,
  CreateClub,
  Settings,
  Signup,
} from 'scenes'
import { module_sponsor, module_dashboard } from 'globalModuleNames';
import { useFeature } from "@growthbook/growthbook-react";
import StatePool from 'state-pool';
import { createStore } from 'state-pool';

const MemberPerspective = lazy(() =>
  import('memberPerspective/components/MemberPerspective')
)

const MemberChat = lazy(() =>
  import('memberPerspective/components/MemberChat')
)

const Container = styled.div`
  font-family: ${(props) => props.theme.fontStack};
`
export const globalState = createStore();

const App = ({
  authenticated,
  ready,
  hasClubs,
  sponsor: {show, path},
  location: {pathname},
  isMember,
  activeClub,
  growthbook,
  isFetchingClubs,
  isFetchingGroups
}) => {

  const [FEATURES_ENDPOINT, setFEATURESENDPOINT] = useState('')
  const [featuresReady, setFeaturesReady] = useState(false);

  const [prevPathname, setPrevPathname] = useState(null)
  const [apiMyOrgUrl, setApiMyOrgUrl] = useState(null)
  const [data, setData] = useState(null)

  // this is used for "Growthbook" to work when changing club
  if (activeClub == null) {
    activeClub = []
    activeClub.id = 0;
  }

  useEffect(() => {
    if (!data) {
      fetch('/paths/paths.json')
        .then((res) => res.json())
        .then((data) => {
          setData(data);
          globalState.setState('apiMyOrgUrl', data.appSettings.apiMyOrgUrl);
          globalState.setState('domainSettings', data.domainSettings);
          setApiMyOrgUrl(data.appSettings.apiMyOrgUrl);
      });
    }

    if (!FEATURES_ENDPOINT && featuresReady === false) {
      getGrowthbookUrl().then(url => {
          fetch(url)
            .then((res) => res.json())
            .then((json) => {
              growthbook.setFeatures(json.features);
              setFEATURESENDPOINT(url)
              setFeaturesReady(true)
          });
      });
    }

    if (prevPathname !== pathname) {
      window.scrollTo(0, 0)
    }

    if (prevPathname) setPrevPathname(pathname)

    if (activeClub) {
      growthbook.setAttributes({
        company: activeClub.id,
      });
    }

  }, [data, prevPathname, ready, apiMyOrgUrl, pathname, activeClub.id, featuresReady])

  if (featuresReady && apiMyOrgUrl && isPhone && !includes(pathname, 'invitation') && !includes(pathname, 'subscription')) {
    return <Directions whiteLabelData={whiteLabelData}/>
  }

  if (featuresReady && apiMyOrgUrl && useFeature(module_sponsor).on) {
    if (show) {
      return <Sponsor path={path} />
    }
  }

  // if (ready && featuresReady && apiMyOrgUrl && data && !hasClubs) {
  //   console.log('hasClubs', hasClubs)
  //   console.log('location', window.location)
  // } else {
  //   console.log('location', window.location)
  //   console.log('hasClubs', hasClubs)
  // }


  return ready && featuresReady && apiMyOrgUrl && data && !isFetchingClubs ? (
      <Container>      
        {authenticated && hasClubs && <Sidebar isMember={isMember} whiteLabelData={data}/>}
          <Content sidebarVisible={authenticated && hasClubs}>
            <Suspense fallback={<p>Loading ...</p>}>
              <Switch>
                <Route exact path="/login" render={(props) => <Login {...props} whiteLabelData={data} />} />
                <Route exact path="/create" render={(props) => <CreateUser {...props} whiteLabelData={data}/>} />
                <Route exact path="/download" render={(props) => <Download {...props} whiteLabelData={data}/>} />
                <Route exact path="/forgot" component={ForgotPassword} />
                <Route exact path="/reset" component={ResetPassword} />
                <Route exact path="/logout" component={Logout} />
                <Route exact path="/create-club" render={(props) => <CreateClub {...props} whiteLabelData={data}/>} />
                  
                <Route path="//subscription/mobilepaysubscription/success" component={SuccessPageForSubscription} />
                <Route path="//subscription/mobilepaysubscription/cancel" component={CancelPageForSubscription} />
                <Route path="//subscription/mobilepaysubscription" component={LandingPageForSubscription} />
                <Route path="/subscription/mobilepaysubscription/success" component={SuccessPageForSubscription} />
                <Route path="/subscription/mobilepaysubscription/cancel" component={CancelPageForSubscription} />
                <Route path="/subscription/mobilepaysubscription" component={LandingPageForSubscription} />

                {authenticated && (
                  <>
                    <Route exact path="/my-page" component={MemberPerspective} />
                    <Route exact path="/chat" component={MemberChat} />
                    {useFeature(module_dashboard).on &&
                      <Route path="/overview" component={Overview} />
                    }
                    <Route path="/members" component={Members} />
                    <Route path="/messages" component={Messages} />
                    <Route path="/activities" component={Activities} />
                    <Route path="/payments" component={Payments} />
                    <Route path="/settings" component={Settings} />
                    <Route path="/onboarding" render={(props) => <Onboarding {...props} whiteLabelData={data}/>} />
                  </>
                )}

                <Route path="/invitation" render={(props) => <Signup {...props} whiteLabelData={data}/>} />
                <Route render={() => <Redirect to="/login" />} />
              </Switch>
            </Suspense>
          </Content>
      </Container>
  ) : null
}

const enhancer = connect(
  createStructuredSelector({
    authenticated: getAuthenticated,
    sponsor: getSponsor,
    hasClubs: getHasClubs,
    isFetchingClubs: getIsFetching,
    isFetchingGroups: getIsFetchingGroups,
    ready: getReady,
    isMember: getIsMember,
    activeClub: getActive,
  })
)

export default enhancer(App)
